import { FeathersModel } from './feathersModel'

export class SentEmail extends FeathersModel {
  static serviceName = 'email-archives'

  from: string
  to: string
  body: string
  createdAt: Date
}
